<template>
  <v-container
    fill-height
    fluid
    grid-list-xl
  >
    <v-layout
      justify-center
      wrap
    >
      <v-flex
        md12
      >
        <div>
          <material-card
            color="general"
            title="Item Parts Data"
            text="List of Item Material"
          >
            <v-layout
              row
              wrap>
              <!--              <v-flex-->
              <!--                xs6-->
              <!--                sm4-->
              <!--                md3-->
              <!--              >-->
              <!--                <v-text-field-->
              <!--                  v-model="search"-->
              <!--                  prepend-icon="search"-->
              <!--                  label="Search"-->
              <!--                  placeholder="search by brand/material/category/desc"-->
              <!--                  clearable-->
              <!--                  single-line-->
              <!--                  hide-details-->
              <!--                />-->
              <!--              </v-flex>-->
              <v-flex
                xs6
                sm4
                md3
              >
                <v-text-field
                  v-model="searchBy.brand"
                  prepend-icon="search"
                  label="Brand"
                  placeholder="Search by Brand"
                  clearable
                  hide-details
                />
              </v-flex>
              <v-flex
                xs6
                sm4
                md3
              >
                <v-text-field
                  v-model="searchBy.category"
                  prepend-icon="search"
                  label="Category"
                  placeholder="Search by Category"
                  clearable
                  hide-details
                />
              </v-flex>
              <v-flex
                xs6
                sm4
                md3
              >
                <v-text-field
                  v-model="searchBy.materialNo"
                  prepend-icon="search"
                  label="Material No"
                  placeholder="Search by Material No."
                  clearable
                  hide-details
                />
              </v-flex>
              <v-flex
                xs6
                sm4
                md3
              >
                <v-text-field
                  v-model="searchBy.materialDesc"
                  prepend-icon="search"
                  label="Material Desc"
                  placeholder="Search by Material Desc"
                  clearable
                  hide-details
                />
              </v-flex>
            </v-layout>
            <v-dialog
              v-model="dialog"
              persistent
              max-width="720px">
              <template v-slot:activator="{ on }">
                <v-btn
                  color="general"
                  class="mb-2 ml-1 mr-1"
                  dark
                  v-on="on">New
                </v-btn>
              </template>
              <v-form
                id="form-vue"
                ref="form"
                v-model="valid"
                :lazy-validation="lazy"
              >
                <v-card>
                  <v-card-text>
                    <v-container grid-list-md>
                      <v-layout wrap>
                        <v-flex
                          xs12
                          sm6
                          md4>
                          <v-text-field
                            v-model="editedItem.brand"
                            :rules="[rules.required,rules.max50chars]"
                            label="Brand *"
                          />
                        </v-flex>
                        <v-flex
                          xs12
                          sm6
                          md4>
                          <v-text-field
                            v-model="editedItem.category"
                            :rules="[rules.max50chars]"
                            label="Category"/>
                        </v-flex>
                        <v-flex
                          xs12
                          sm6
                          md4>
                          <v-select
                            :items="currencyList"
                            v-model="editedItem.currency"
                            :rules="[rules.required]"
                            menu-props="auto"
                            item-text="code"
                            item-value="code"
                            label="Currency *"
                            placeholder="Select..."
                          />
                        </v-flex>
                        <v-flex
                          xs12
                          sm6
                          md4>
                          <v-text-field
                            v-model="editedItem.materialNo"
                            :rules="[rules.required,rules.max50chars]"
                            label="Material No *"/>
                        </v-flex>
                        <v-flex
                          xs12
                          sm6
                          md4>
                          <!--                          <v-text-field-->
                          <!--                            v-model="editedItem.supplier"-->
                          <!--                            :rules="[rules.max50chars]"-->
                          <!--                            label="Supplier"/>-->
<!--                          <v-select-->
<!--                            :items="suppliers"-->
<!--                            v-model="editedItem.supplier"-->
<!--                            menu-props="auto"-->
<!--                            item-text="name"-->
<!--                            item-value="id"-->
<!--                            label="Supplier"-->
<!--                            placeholder="Select..."-->
<!--                            return-object-->
<!--                          ></v-select>-->
                              <v-autocomplete
                                v-model="editedItem.supplier"
                                :items="suppliers"
                                :search-input.sync="searchSupplier"
                                hide-no-data
                                placeholder="type 3 words to search..."
                                label="Supplier *"
                                item-text="name"
                                item-value="id"
                                return-object
                              ></v-autocomplete>
                        </v-flex>
                        <v-flex
                          xs12
                          sm12
                          md12>
                          <v-textarea
                            v-model="editedItem.materialDesc"
                            :rules="[rules.required]"
                            label="Description"
                            clearable
                          />
                        </v-flex>
                        <v-flex
                          xs12
                          sm6
                          md4>
                          <v-text-field
                            v-model="editedItem.price.suppPrice"
                            :rules="[rules.number, rules.required]"
                            label="Supplier Price *"/>
                        </v-flex>
                        <v-flex
                          xs12
                          sm6
                          md4>
                          <v-text-field
                            v-model="editedItem.price.sellingPrice"
                            :rules="[rules.number]"
                            label="Selling Price"/>
                        </v-flex>
                        <v-flex
                          xs12
                          sm6
                          md4>
                          <v-text-field
                            v-model="editedItem.price.bottomPrice"
                            :rules="[rules.number]"
                            label="Bottom Price"/>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer/>
                    <v-btn
                      color="red darken-1"
                      flat
                      @click="close">Cancel
                    </v-btn>
                    <v-btn
                      :disabled="!valid"
                      color="green darken-1"
                      flat
                      @click="save">Save
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-form>
            </v-dialog>
            <v-btn
              color="general"
              class="mb-2 ml-1 mr-1"
              dark
              @click.stop="openApplyPrice">Apply Rule
            </v-btn>
            <v-btn
              color="general"
              dark
              @click="$refs.downloadExcel.generate()"
            >
              <download-excel
                ref="downloadExcel"
                :fetch="fetchData"
                :fields="excelFields"
                :before-generate="showProgressBar"
                :before-finish="hideProgressBar"
                class="btn btn-default"
                worksheet="worksheet"
                name="item_material-All.xls">
                <v-icon>mdi-file-excel</v-icon>
              </download-excel>&nbsp;Export All
            </v-btn>
            <v-btn
              :disabled="selectFileDisabled"
              class="mb-2 ml-1 mr-1"
              dark
              color="general"
              @click="$refs.inputUpload.click()">
              Select&nbsp;<v-icon>mdi-file-excel</v-icon>
            </v-btn>
            <input
              v-show="false"
              ref="inputUpload"
              type="file"
              @change="loadFile"
            >
            <v-chip
              v-show="showFilename"
              class="ma-1"
              color="general"
              label
              outline
            >
              <v-icon left>mdi-file-check</v-icon>
              {{ file.name }}
            </v-chip>
            <v-btn
              :loading="uploadFileLoading"
              :disabled="uploadFileDisabled"
              :dark="!uploadFileDisabled"
              color="general"
              class="mb-2 ml-1 mr-1"
              @click="uploadFile">Upload&nbsp;
              <v-icon>mdi-upload</v-icon>
            </v-btn>
            <v-progress-linear
              v-show="uploadFileLoading"
              :indeterminate="true"/>
            <v-data-table
              id="datatable"
              v-model="selected"
              :loading="loading"
              :headers="headers"
              :items="DataList"
              :rows-per-page-items="rowsAmount"
              :pagination.sync="pagination"
              :total-items="totalRows"
              :expand="expand"
              item-key="id"
              dense
              select-all
              loading-text="Loading... Please wait"
              class="elevation-1"
            >
              <!--  change table header background and text color(or other properties) -->
              <!--              <template-->
              <!--                slot="headerCell"-->
              <!--                slot-scope="{ header }"-->
              <!--              >-->
              <!--                <span-->
              <!--                  class="subheading font-weight-light text-general text&#45;&#45;darken-3"-->
              <!--                  dense-->
              <!--                  v-text="header.text"-->
              <!--                />-->
              <!--              </template>-->
              <!--              <template v-slot:items="props" >-->
              <!--                <td>{{ props.item.brand }}</td>-->
              <!--                <td>{{ props.item.category }}</td>-->
              <!--                <td>{{ props.item.materialNo }}</td>-->
              <!--                <td>{{ props.item.materialDesc }}</td>-->
              <!--                <td>{{ props.item.price.suppPrice }}</td>-->
              <!--                <td>{{ props.item.price.sellingPrice }}</td>-->
              <!--                <td>{{ props.item.price.bottomPrice }}</td>-->
              <!--                <td>{{ props.item.curr }}</td>-->
              <!--                <td>{{ props.item.lastUpdateBy }}</td>-->
              <!--                <td>{{ toStringDate(props.item.lastUpdateDate) }}</td>-->
              <!--                <td class="justify-center ">-->
              <!--                  <v-icon-->
              <!--                    medium-->
              <!--                    class="mr-2"-->
              <!--                    @click="editItem(props.item)">edit</v-icon>-->
              <!--                  <v-icon-->
              <!--                    medium-->
              <!--                    @click="dialogDeleteShow(props.item)">delete-->
              <!--                  </v-icon>-->
              <!--                </td>-->

              <!--              </template>-->
              <!--               Checkbox implementation -->
              <!--              <template v-slot:headers="props">-->
              <!--                <tr>-->
              <!--                  <th>-->
              <!--                    &lt;!&ndash;                    <v-checkbox&ndash;&gt;-->
              <!--                    &lt;!&ndash;                      :input-value="props.all"&ndash;&gt;-->
              <!--                    &lt;!&ndash;                      :indeterminate="props.indeterminate"&ndash;&gt;-->
              <!--                    &lt;!&ndash;                      primary&ndash;&gt;-->
              <!--                    &lt;!&ndash;                      hide-details&ndash;&gt;-->
              <!--                    &lt;!&ndash;                      @click.stop="toggleAll"&ndash;&gt;-->
              <!--                    &lt;!&ndash;                    />&ndash;&gt;-->
              <!--                  </th>-->
              <!--                  <th-->
              <!--                    v-for="header in props.headers"-->
              <!--                    :key="header.text"-->
              <!--                    :class="['column sortable', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"-->
              <!--                    @click="changeSort(header.value)"-->
              <!--                  >-->
              <!--                    <span-->
              <!--                      class="subheading font-weight-light text-general text&#45;&#45;darken-3"-->
              <!--                      dense-->
              <!--                      v-text="header.text"-->
              <!--                    />-->
              <!--                    <v-icon small>arrow_upward</v-icon>-->
              <!--                  </th>-->
              <!--                </tr>-->
              <!--              </template>-->
              <template v-slot:items="props">
                <tr
                  class="expandable"
                  @click.stop=" (props.expanded = !props.expanded)">
                  <td>
                    <v-checkbox
                      v-model="props.selected"
                      hide-details
                      primary
                      @click.stop="props.selected = !props.selected"
                    />
                  </td>
                  <td>{{ props.item.brand }}</td>
                  <td>{{ props.item.category }}</td>
                  <td>{{ props.item.materialNo }}</td>
                  <!-- <td>{{ props.item.materialDesc }}</td>-->
                  <td>{{ props.item.supplier ? props.item.supplier.name : '' }}</td>
                  <td class="price-format">{{ toPriceFormat(props.item.price.suppPrice) }}</td>
                  <td class="price-format">{{ toPriceFormat(props.item.price.sellingPrice) }}</td>
                  <td class="price-format">{{ toPriceFormat(props.item.price.bottomPrice) }}</td>
                  <td>{{ props.item.currency }}</td>
                  <td>{{ props.item.lastUpdateBy }}</td>
                  <td>{{ toStringDate(props.item.lastUpdateDate) }}</td>
                  <td class="justify-center ">
                    <v-icon
                      medium
                      class="mr-2"
                      @click.stop="editItem(props.item)">edit
                    </v-icon>
                    <v-icon
                      medium
                      @click.stop="dialogDeleteShow(props.item)">delete
                    </v-icon>
                  </td>
                </tr>
              </template>
              <template v-slot:expand="props">
                <v-flex mx-3>
                  <v-card>
                    <v-card-text align="left"><span class="expand-item">Material Desc:</span> {{ props.item.materialDesc
                    }}
                    </v-card-text>
                  </v-card>
                </v-flex>
              </template>
            </v-data-table>
            <v-snackbar
              v-model="snack"
              :timeout="5000"
              :color="snackColor">
              {{ snackText }}
              <v-icon
                size="16"
                @click="snack = false"
              >
                mdi-close-circle
              </v-icon>
            </v-snackbar>
          </material-card>
        </div>
      </v-flex>

      <v-dialog
        v-model="dialogDelete"
        max-width="400px">
        <v-card>
          <v-card-title class="headline">System Message Confirmation</v-card-title>
          <v-card-text>
            Are you sure want to remove this data? <br>
            "{{ deleteItemRecord.brand }} - {{ deleteItemRecord.materialNo }}"
          </v-card-text>
          <v-card-actions>
            <v-spacer/>

            <v-btn
              color="red darken-1"
              text
              flat
              @click="dialogDelete = false"
            >
              Cancel
            </v-btn>

            <v-btn
              color="green darken-1"
              text
              flat
              @click="deleteItem(deleteItemRecord)"
            >
              Ok
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="dialogApplyPrice"
        persistent
        max-width="500px">
        <v-form
          id="applyprice-form-vue"
          ref="form2"
          v-model="validApplyPrice"
          :lazy-validation="lazyApplyPrice"
        >
          <v-card>
            <v-card-text>
              <v-chip
                v-for="item in selected"
              >{{ item.brand }}
                <v-icon>mdi-tilde</v-icon>
                {{ item.materialNo }}
              </v-chip>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex
                    xs6
                    sm6
                    md4>
                    <v-select
                      :items="priceRuleList"
                      v-model="applyPriceItem.priceRuleObj"
                      :rules="[rules.requiredObj]"
                      menu-props="auto"
                      item-text="name"
                      item-value="id"
                      label="Price Rule *"
                      placeholder="Select..."
                      return-object
                    />
                  </v-flex>
                  <v-flex
                    xs6
                    sm6
                    md4>
                    <v-select
                      v-if="selected.length < 1"
                      :items="itemBrandDistinctList"
                      v-model="applyPriceItem.brand"
                      :rules="[rules.required]"
                      menu-props="auto"
                      label="Brand"
                      placeholder="Select..."
                      @input="getItemBrandCategoryDistinct"
                    />
                  </v-flex>
                  <v-flex
                    xs6
                    sm6
                    md4>
                    <v-select
                      v-if="selected.length < 1"
                      :items="itemBrandCategoryDistinctList"
                      v-model="applyPriceItem.category"
                      menu-props="auto"
                      label="Category"
                      placeholder="Select..."
                    />
                  </v-flex>
                  <v-flex
                    xs6
                    sm6
                    md4>
                    <v-text-field
                      v-model="applyPriceItem.priceRuleObj.opsMultiplier"
                      disabled
                      label="Multiplier Factor"/>
                  </v-flex>
                  <v-flex
                    xs6
                    sm6
                    md4>
                    <v-text-field
                      v-model="applyPriceItem.priceRuleObj.opsAddition"
                      disabled
                      label="Addition Factor"/>
                  </v-flex>
                  <v-flex
                    xs6
                    sm6
                    md4>
                    <v-text-field
                      v-model="applyPriceItem.priceRuleObj.discMax"
                      disabled
                      label="Disc Max(%)"/>
                  </v-flex>
                  <v-flex
                    xs6
                    sm6
                    md4>
                    <v-textarea
                      v-model="applyPriceItem.priceRuleObj.desc"
                      disabled
                      label="Description"/>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer/>
              <v-btn
                color="red darken-1"
                flat
                @click="close">Cancel
              </v-btn>
              <v-btn
                :disabled="!validApplyPrice"
                color="green darken-1"
                flat
                @click="applyPriceToItem">Save
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-dialog>

      <v-dialog
        v-model="dialogUploadFinish"
        scrollable
        persistent
        max-width="480px">
        <v-card>
          <v-card-title class="headline">Import Excel Information</v-card-title>
          <v-card-text>
            <div
              class="body-1"
              style="white-space: pre;">{{ uploadResponse.errMessage }}</div>
          </v-card-text>
          <v-card-actions>
            <v-spacer/>
            <v-btn
              color="green darken-1"
              text
              flat
              @click="dialogUploadFinish = false"
            >
              OK
            </v-btn>

          </v-card-actions>
        </v-card>
      </v-dialog>
      <!--      <item-bundling-->
      <!--        v-if="DataList.length > 0"-->
      <!--        :items-non-bundling="DataList"-->
      <!--        :currency-list="currencyList" />-->
    </v-layout>
  </v-container>
</template>

<script>
  import displayFormatterMixins from '../../../mixins/displayFormatterMixins'
  // import ItemBundling from './ItemBundling'
  import jsonCurrency from '../../../i18n/Currencies.json'
  import _ from 'lodash'

  export default {
    name: 'Item',
    // components: { ItemBundling },
    mixins: [displayFormatterMixins],
    data: () => ({
      currencyList: jsonCurrency,
      dialogUploadFinish: false,
      uploadResponse: {},
      snack: false,
      valid: false,
      expand: true,
      validApplyPrice: false,
      lazy: false,
      lazyApplyPrice: false,
      snackColor: '',
      snackText: '',
      checkAll: false,
      selected: [],
      rules: {
        requiredObj: obj => !!(Object.entries(obj).length !== 0) || 'Required.',
        required: value => !!value || 'Required.',
        requiredRuleOps: function (value) {
          console.log(this.selected)
          return !!value || 'Required.'
        },
        max50chars: value => !value || value.length <= 50 || 'Max 50 characters',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return !value || pattern.test(value) || 'Invalid e-mail.'
        },
        number: value => !isNaN(value) || 'Must be numeric'
      },
      pagination: {},
      DataList: [],
      priceRuleList: [],
      itemBrandCategoryDistinctList: [],
      itemBrandDistinctList: [],
      totalRows: 0,
      rowsAmount: [5, 20, 50, 100],
      // rowsAmount: [5, 20, 25, { 'text': '$vuetify.dataIterator.rowsPerPageAll', 'value': -1 }],
      dialog: false,
      dialogApplyPrice: false,
      dialogDelete: false,
      deleteItemRecord: {},
      loading: true,
      search: '',
      searchSupplier: '',
      searchBy: {
        brand: '',
        category: '',
        materialNo: '',
        materialDesc: ''
      },
      headers: [
        { text: 'Brand', value: 'brand' },
        { text: 'Category', value: 'category' },
        { text: 'Material', value: 'materialNo', class: 'header-datatable' },
        // { text: 'Desc', value: 'materialDesc' },
        { text: 'Supplier', value: 'supplier.name' },
        { text: 'Supp Price', value: 'price.suppPrice', align: 'right' },
        { text: 'Selling Price', value: 'price.sellingPrice', align: 'right' },
        { text: 'Bottom Price', value: 'price.bottomPrice', align: 'right' },
        { text: 'Curr', value: 'curr' },
        { text: 'Update By', value: 'lastUpdateBy' },
        { text: 'Update Date Time', value: 'lastUpdateDate' },
        { text: '--Actions--', value: 'actions', sortable: false }
      ],
      excelFields:
        {
          'Brand (*)': 'brand',
          'Category (*)': 'category',
          'Material (*)': 'materialNo',
          'Material Desc (*)': 'materialDesc',
          'Currency (*)': 'currency',
          'Supp Price (*)': 'price.suppPrice',
          'Supplier (optional)': {
            callback: (value) => {
              return value.supplier ? value.supplier.name : ''
            }
          },
          'Selling Price': 'price.sellingPrice',
          'Bottom Price': 'price.bottomPrice',
          'Update By': 'lastUpdateBy',
          'Update Date Time': {
            callback: (value) => {
              return new Date(value.lastUpdateDate).toLocaleString('en-GB')
            }
          }
        },

      companies: [],
      suppliers: [],
      editedIndex: -1,
      applyPriceItem: {
        priceRuleObj: {},
        idItems: []
      },
      editedItem: {
        id: null,
        brand: '',
        materialNo: '',
        materialDesc: '',
        price: {
          suppPrice: '',
          sellingPrice: '',
          bottomPrice: ''
        },
        currency: '',
        category: '',
        // supplier: '', // TODO remove this after done migration
        supplier: {
          id: '',
          name: ''
        }
      },
      defaultItem: {
        id: null,
        brand: '',
        materialNo: '',
        materialDesc: '',
        price: {
          suppPrice: '',
          sellingPrice: '',
          bottomPrice: ''
        },
        currency: '',
        category: '',
        // supplier: '', // TODO remove this after done migration
        supplier: {
          id: '',
          name: ''
        }
      },
      file: {},
      selectFileDisabled: false,
      uploadFileDisabled: true,
      uploadFileLoading: false,
      showFilename: false
    }),
    computed: {

    },

    watch: {
      dialog (val) {
        val || this.close()
      },
      pagination: {
        async handler () {
          console.debug('pagination watcher')
          this.getItems()
        }
      },
      search () {
        console.debug('search watcher')
        this.debouncedGetItems()
      },
      searchBy: {
        handler (oldVal, newVal) {
          console.debug('searchBy Deep')
          this.debouncedGetItems()
        },
        deep: true
      },
      searchSupplier () {
        console.debug('searchSupplier watcher: ' + this.searchSupplier)
        if (this.searchSupplier && this.searchSupplier.length >= 3) {
          this.debouncedGetSupplier()
        }
      }
    },
    // called after dom render
    mounted () {
      // this.getItems()
    },
    // called before dom render, can access reactive data
    created: function () {
      this.debouncedGetItems = _.debounce(this.getItems, 500)
      this.debouncedGetSupplier = _.debounce(this.getSupplierPaging, 500) //TODO for autocomplete
      // this.getSuppliers()
    },

    methods: {
      async fetchData () {
        const response = await this.$http.get(`/api/item/all`)
        return response.data
      },
      showProgressBar () {
        this.uploadFileLoading = true
      },
      hideProgressBar () {
        this.uploadFileLoading = false
      },
      openApplyPrice (isSelect = 1) {
        console.debug(this.selected)
        // if (this.selected.length <= 0) {
        //   this.checkboxSnack()
        // } else {
          this.getPriceRule()
          this.getItemBrandDistinct()
          this.dialogApplyPrice = true
        // }
      },
      toggleAll () {
        if (this.selected.length) this.selected = []
        else this.selected = this.DataList.slice()
      },
      changeSort (column) {
        if (this.pagination.sortBy === column) {
          this.pagination.descending = !this.pagination.descending
        } else {
          this.pagination.sortBy = column
          this.pagination.descending = false
        }
      },
      async getItems () {
        try {
          this.loading = true
          const { sortBy, descending, page, rowsPerPage } = this.pagination
          let q = this.search == null ? '' : this.search
          console.log(this.searchBy.brand)
          let qbra = this.searchBy.brand == null ? '' : this.searchBy.brand
          let qcat = this.searchBy.category == null ? '' : this.searchBy.category
          let qmat = this.searchBy.materialNo == null ? '' : this.searchBy.materialNo
          let qdes = this.searchBy.materialDesc == null ? '' : this.searchBy.materialDesc
          console.debug(this.pagination)
          let pageNoXHR = page - 1
          let response = await this.$http.get(`/api/item?ps=${rowsPerPage}&pn=${pageNoXHR}&so=${sortBy || 'Brand'}
          &dc=${descending || false}&q=${q}&qbra=${qbra}&qcat=${qcat}&qmat=${qmat}&qdes=${qdes}`)
          this.loading = false
          this.DataList = response.data.content
          this.totalRows = response.data.totalElements
        } catch (error) {
          console.log(error)
        }
      },
      async getPriceRule () {
        try {
          let response = await this.$http.get('/api/pricerule?so=name')
          this.priceRuleList = response.data.content
        } catch (error) {
          console.log(error)
        }
      },
      async getItemBrandDistinct () {
        try {
          let response = await this.$http.get('/api/item/brand/select')
          this.itemBrandDistinctList = response.data
        } catch (error) {
          console.log(error)
        }
      },
      async getItemBrandCategoryDistinct () {
        try {
          let response = await this.$http.get(`/api/item/category/select?brand=${this.applyPriceItem.brand}`)
          this.itemBrandCategoryDistinctList = response.data
        } catch (error) {
          console.log(error)
        }
      },
      async getSupplierPaging () { // paging not yet implemented
        try {
          // const { sortBy, descending, page, rowsPerPage } = this.pagination
          let q = this.searchSupplier == null ? '' : this.searchSupplier
          // let pageNoXHR = page - 1
          // let response = await this.$http.get(`/api/company/select?ps=${rowsPerPage}&pn=${pageNoXHR}&so=${sortBy}&dc=${descending}&q=${q}`)
          let response = await this.$http.get(`api/supplier/autocomplete?ps=100&pn=0&so=name&q=${q}`)

          this.suppliers = response.data
        } catch (error) {
          console.log(error)
        }
      },
      async getSuppliers () {
        try {
          let response = await this.$http.get('/api/supplier/select')
          this.suppliers = response.data
        } catch (error) {
          console.log(error)
        }
      },

      // object.assign fills in the empty object with the properties of item
      editItem (item, dbox = true) {
        this.editedIndex = this.DataList.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = dbox
      },

      dialogDeleteShow (data) {
        this.dialogDelete = true
        this.deleteItemRecord = data
      },

      deleteItem (rec) {
        let endpoint = `api/item/${rec.id}`
        let method = 'delete'
        let s = {}
        this.DataList.splice(this.DataList.indexOf(rec), 1)
        this.$store.dispatch('updateTableItem', { endpoint, s, method })
          .then((response) => this.deleteInline())
          .catch(error => {
            console.log(error)
            this.cancelInline()
          })
        this.dialogDelete = false
      },

      close () {
        this.dialog = false
        this.dialogApplyPrice = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
          this.applyPriceItem = Object.assign({}, {
            priceRuleObj: {},
            idItems: [],
            sellingPrice: '',
            suppPrice: '',
            brand: '',
            category: ''
          })
          this.selected = []
        }, 300)
      },
      async loadFile (e) {
        /** Load same file would not work!! @change event **/
        // const files = e.target.files
        const fileref = this.$refs.inputUpload.files
        console.debug(fileref.length)
        if (fileref[0] == undefined || fileref[0].type != 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
          this.fileFormatSnack()
          return
        }
        if (fileref[0] !== undefined) {
          console.debug(fileref[0].name)
          console.debug('Type: ' + fileref[0].type)
          console.debug('Size: ' + fileref[0].size + ' bytes')
          const fr = new FileReader()
          fr.readAsDataURL(fileref[0])
          fr.addEventListener('load', async () => {
            // console.debug(fr.result)
            // this.imageFile = files[0] // this is an image file that can be sent to server...
            // let response = await this.$store.dispatch('uploadFile', { file, endpoint })
            // console.debug(response)
            this.file = fileref[0]
            this.showFilename = true
            this.uploadFileDisabled = false
          })
        } else {
          this.file = {}
        }
      },
      async uploadFile () {
        let endpoint = 'api/excel/item'
        let filexls = this.file
        console.debug(this.file)
        try {
          this.uploadFileLoading = true
          this.uploadFileDisabled = true
          this.selectFileDisabled = true
          let response = await this.$store.dispatch('uploadFile', { filexls, endpoint })
          this.uploadResponse = response.data
          console.log(this.uploadResponse)
          this.dialogUploadFinish = true
          this.getItems()
        } catch (error) {
          console.log(error)
          this.cancelInline()
        }
        this.showFilename = false
        this.uploadFileLoading = false
        this.selectFileDisabled = false
        this.file = {}
        this.$refs.inputUpload.value = '' // make sure it is free from file object
      },

      async applyPriceToItem () {
        this.applyPriceItem.idItems = Array.from(this.selected, x => x.id)
        let tableItem = this.applyPriceItem
        let endpoint = `api/item/price`
        let method = 'post'
        try {
          await this.$store.dispatch('updateTableItem', { endpoint, tableItem, method })
          this.getItems()
          this.saveInline()
        } catch (error) {
          console.log(error)
          this.cancelInline()
        }
        this.close()
      },

      save () {
        if (!this.$refs.form.validate()) {
          console.debug('validation fail direct')
        }
        if (this.$refs.form.validate()) {
          console.debug('validation success')
        }
        if (this.editedIndex > -1) {
          Object.assign(this.DataList[this.editedIndex], this.editedItem)
          let tableItem = this.editedItem
          let endpoint = `api/item/${this.editedItem.id}`
          let method = 'patch'
          this.$store.dispatch('updateTableItem', { endpoint, tableItem, method })
            .then((response) => this.saveInline())
            .catch(error => {
              console.log(error)
              this.cancelInline()
            })
        } else {
          let tableItem = this.editedItem
          this.DataList.push(this.editedItem)
          let endpoint = `api/item`
          let method = 'post'
          this.$store.dispatch('updateTableItem', { endpoint, tableItem, method })
            .then((response) => {
              if (response.data.message === 'FAILED') {
                this.cancelInline(response.data.details)
              } else {
                this.saveInline()
                this.getItems()
              }
            })
            .catch(error => {
              console.log(error)
              this.cancelInline()
            })
        }
        this.close()
      },
      // toasts/snackbar messages for actions
      importMessage (msg) {
        this.snack = true
        this.snackColor = 'warning'
        this.snackText = msg
      },
      saveInline () {
        this.snack = true
        this.snackColor = 'success'
        this.snackText = 'Data saved/updated'
      },
      cancelInline (txt) {
        this.snack = true
        this.snackColor = 'error'
        this.snackText = txt || 'Canceled'
      },
      deleteInline () {
        this.snack = true
        this.snackColor = 'success'
        this.snackText = 'Data removed'
      },
      reset () {
        this.snack = true
        this.snackColor = 'success'
        this.snackText = 'Data reset to default'
      },
      openInline () {
        this.snack = true
        this.snackColor = 'info'
        this.snackText = 'Dialog opened'
      },
      closeInline () {
        console.debug('Dialog closed')
      },
      checkboxSnack () {
        this.snack = true
        this.snackColor = 'error'
        this.snackText = 'Please select at least one'
      },
      fileFormatSnack () {
        this.snack = true
        this.snackColor = 'error'
        this.snackText = 'Please select xls/xlsx file'
      }
    }
  }
</script>
